/* global G */
import { Typography } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { useContext } from 'react'
import ApplicationContext from 'platform/react/context/application'

/**
 * Displays a cell with the label of a TypeExtension.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 * @returns {React.ReactNode}
 */
export const ListItemCellTypeExtensionLabel = (classes, props = {}) => {
  const { session } = useContext(ApplicationContext)
  const language = session[G.LANGUAGE]
  const { label: { [language]: label = props.label } = {} } = props

  return (
    <Typography
      color={'black'}
      variant={'14/regular'}
      className={classes.row}
      sx={{ fontWeight: 700 }}
    >
      {label}
    </Typography>
  )
}

export default CellHOC(ListItemCellTypeExtensionLabel)
